import { useEffect } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'

import { getCoachCertification } from '../../../actions/coachCertificationActions'

export const useCoachCertification = (certificationId, { refresh = false } = {}) => {
  const dispatch = useDispatch()
  const store = useStore()
  const { certification, notFound, failed } = useSelector(state => state.coachCertification)
  const id = Number(certificationId)

  useEffect(() => {
    if (refresh || store.getState().coachCertification.requestedId !== id) { dispatch(getCoachCertification(id)) }
  }, [dispatch, store, id, refresh])

  return { certification: certification?.id === id ? certification : null, notFound, failed }
}
